import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTextarea',
  props: {
    id: {},
    modelValue: {}
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const inputUpdated = (e) => {
	emit('update:modelValue', e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    id: __props.id,
    value: __props.modelValue,
    cols: "50",
    rows: "20",
    onInput: inputUpdated
  }, null, 40, _hoisted_1))
}
}

})